import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeSessionId, setStoredBearer, useAuth } from "../lib/auth";

export default function AuthCallbackPage() {
  const [status, setStatus] = useState("processing"); // processing | done | error
  const [error, setError] = useState("");
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        // Emergent returns ...#session_id=<id>
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
          setStatus("error");
          setError("No session_id received. Try signing in again.");
          return;
        }
        const session_id = decodeURIComponent(m[1]);
        const res = await exchangeSessionId(session_id);
        // Backend returns the long-lived session_token; store as bearer (cookies are unreliable cross-origin).
        if (res?.session_token) setStoredBearer(res.session_token);
        await refresh();
        // Clear hash to avoid replays
        window.history.replaceState({}, document.title, window.location.pathname);
        toast.success(`Welcome${res.user?.name ? `, ${res.user.name.split(" ")[0]}` : ""}.`);
        setStatus("done");
        // If username not set, go to setup; else to archive
        if (!res.user?.username) {
          navigate("/me/archive?setup=1", { replace: true });
        } else {
          navigate("/archive/drop", { replace: true });
        }
      } catch (e) {
        setStatus("error");
        setError(e?.response?.data?.detail || "Auth failed.");
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback-page">
      <div className="text-center max-w-md px-6">
        <div className="text-[10px] tracking-[0.32em] uppercase text-[#C5A059]">The Archive Recognizes You</div>
        <h1 className="font-display text-3xl md:text-4xl text-[#EAE0D5] mt-3">
          {status === "processing" ? "Sealing your seat…" : status === "done" ? "Welcome." : "Something interrupted the signal."}
        </h1>
        {status === "error" && (
          <>
            <p className="text-sm text-[#A39E99] mt-3">{error}</p>
            <button
              onClick={() => navigate("/login")}
              className="mt-6 bg-[#C5A059] text-black px-6 py-3 text-xs tracking-[0.24em] uppercase hover:bg-[#D4AF68]"
              data-testid="auth-callback-retry"
            >
              Try Again
            </button>
          </>
        )}
        {status === "processing" && (
          <p className="text-xs text-[#737373] mt-4 tracking-[0.2em] uppercase">Verifying your record…</p>
        )}
      </div>
    </div>
  );
}
